import { motion } from 'framer-motion';
import {
  FiCloud,
  FiShield,
  FiCpu,
  FiLayers,
  FiBarChart2,
  FiHeadphones,
} from 'react-icons/fi';

const services = [
  {
    icon: FiCloud,
    title: 'Cloud & infrastructure',
    desc: 'Architecture, migration, and cost-aware operations across public and hybrid environments.',
  },
  {
    icon: FiShield,
    title: 'Cybersecurity',
    desc: 'Identity, zero-trust patterns, monitoring, and incident readiness tailored to your risk profile.',
  },
  {
    icon: FiCpu,
    title: 'Managed IT',
    desc: 'Endpoints, networks, and service desk—so your teams stay productive without firefighting.',
  },
  {
    icon: FiLayers,
    title: 'Applications & integration',
    desc: 'Modernize legacy workflows, APIs, and business systems with maintainable delivery practices.',
  },
  {
    icon: FiBarChart2,
    title: 'Data & insights',
    desc: 'Pipelines, governance, and reporting that turn fragmented data into decisions.',
  },
  {
    icon: FiHeadphones,
    title: 'Advisory & support',
    desc: 'Roadmaps, vendor alignment, and 24/7 options scaled to your operating model.',
  },
];

const Services = () => {
  return (
    <section id="services" className="py-20 md:py-28 relative scroll-mt-24 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-14"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Capabilities built for <span className="text-gradient">real operations</span>
          </h2>
          <p className="text-slate-600 text-lg">
            Pick the engagements you need—we assemble the right specialists and playbooks for your
            industry and compliance context.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.article
              key={s.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ delay: i * 0.05, duration: 0.45 }}
              className="group rounded-2xl border border-slate-200 bg-surface-card shadow-card p-6 hover:border-brand-cyan/40 hover:shadow-lg transition-all duration-300"
            >
              <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-brand/10 text-brand-violet ring-1 ring-slate-100 group-hover:ring-brand-cyan/25 transition-all">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="font-display font-semibold text-lg text-slate-900 mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{s.desc}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
